export default import.meta.ROLLDOWN_FILE_URL_YBzZ1Z0faY$7r7kp5_byMg